import { Controller} from "stimulus";

/**
 * Nimmt alle Kindelemente und mischt sie in zufälliger Reihenfolge
 */
export default class extends Controller {
    connect() {
        Array.from(this.element.children)
            .sort(() => Math.random() - 0.5)
            .forEach(elem => this.element.append(elem));
    }
}